export default [
  { label: '1. des Monats', value: 1 },
  { label: '15. des Monats', value: 15 }
]
